import React from 'react'; 
import image from '../images/s_image_text.png';
import style from '../css/Component2.module.css';

function Two() {
	return (
		<div className={style.container}>
			<img src={image} alt="" className={style.image} />

			<div className={style.box}>
				<h1 className={style.header}>Top quality appliance repairs</h1>
				<p className={style.desc}>
					Our repairs are built for durability, efficiency, and reliability.
					With meticulous attention to detail, we ensure your appliances are
					restored to optimal performance.
				</p>
				<p className={style.desc}>
					Our focus is on providing the best customer experience by
					understanding their needs and providing them with the right solutions.
				</p>
			</div>
		</div>
	);
}

export default Two;
